import { useDisclosure } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { useRef, useState } from 'react';

import Box from '~/common/components/Box';
import Button from '~/common/components/Buttons/Button/index';
import Text from '~/common/components/Texts/Text';
import Drawer from '~/common/mui/Drawers/Drawer';
import { typedApiClient } from '~/common/util/api-client';
import { keys } from '~/pages/IncomeCalculator/CalculationHistory/keys';
import { useIncomeIdentifier } from '~/pages/IncomeCalculator/hooks';
import lang from '~/pages/IncomeCalculator/language.json';

import HistoryDrawer from './HistoryDrawer';

const CalculationHistory = ({ ...props }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const buttonRef = useRef();
  const [selectedCalculation, setSelectedCalculation] = useState(null);
  const { obfuscatedLoanIdentifier, incomeIdentifier, addressIdentifier } =
    useIncomeIdentifier();

  const { isLoading, data: summaries } = useQuery({
    queryKey: incomeIdentifier
      ? keys.forEmployer(incomeIdentifier)
      : keys.forProperty(addressIdentifier),
    async queryFn() {
      const { data } =
        await typedApiClient.v1.incomeCalculatorGetCalculationsHistory({
          obfuscatedLoanIdentifier,
          incomeIdentifier,
          addressIdentifier,
        });
      return data.calculationSummaries;
    },
  });

  if (isLoading || !summaries || summaries.length === 0) {
    return null;
  }

  return (
    <>
      <Box {...props}>
        <Button
          variant="outline"
          colorScheme="blue"
          maxWidth="175px"
          zIndex={5}
          ref={buttonRef}
          onClick={() => onOpen()}
        >
          <Text as="span" color={props?.textColor ?? 'gray.900'}>
            {lang.CALC_HISTORY}
          </Text>
        </Button>
      </Box>
      <Drawer
        isOpen={isOpen}
        placement="right"
        size={selectedCalculation ? 'xl' : 'lg'}
        onClose={onClose}
        finalFocusRef={buttonRef}
      >
        {isOpen && (
          <HistoryDrawer
            data={summaries}
            selectedCalculation={selectedCalculation}
            setSelectedCalculation={setSelectedCalculation}
          />
        )}
      </Drawer>
    </>
  );
};

export default CalculationHistory;
